import office365logo from "../../../../assets/office365logo.png";
const Office365Logo = () => {
  return <img src={office365logo} style={{ width: "86.67px", height: "20px" }} alt="Office 365 Logo" />;
};

export default Office365Logo;